import {
	isStoreHuman,
	type StoreChatItem,
} from '@atlassian/conversation-assistant-store/controllers/chat/types';

export const updateHumanMessageId = ({
	chat,
	oldId,
	newId,
	parentMessageId,
}: {
	chat: StoreChatItem[];
	oldId: string;
	newId: string;
	parentMessageId?: string | null;
}): StoreChatItem[] =>
	chat.map((message) => {
		if (isStoreHuman(message) && message.content.id === oldId) {
			return {
				...message,
				content: {
					...message.content,
					id: newId,
					...(parentMessageId && { parent_message_id: parentMessageId }),
				},
			};
		}
		return message;
	});
